import React from "react";

import VboardStates from "../data/VboardStates.js";

//Input: 
//array of a board state of user results as an array [1,2,0,3,4...0,1] 
//the task Id of the corresponding task 
//testEnd will output error if accessed directly wihtout taking the test first.
  
function ScoreFunction (userTaskResult, taskId){
		
	//changing the task from type string ("10010230...12340"] to type array [1,0,0,1,0,2,3,0,...1,2,3,4,0]
	//remove the first element (indicating if the board is numbered or not numbered) since in the userTaskResult is always 0 regardless the type of board
	const taskBoardStateAsArray=
		VboardStates[taskId].slice(1,).split('').map
		(function(item) {
			return (parseInt(item, 10));
		})
	
	//remove the first element from userTaskResult(indicating if the board is numbered or not numbered)
	const sum = userTaskResult.slice(1,).map((a, i) => a + taskBoardStateAsArray[i])
	const difference = userTaskResult.slice(1,).map((a, i) => a - taskBoardStateAsArray[i]);
		
	const nonzeroSum = sum.filter (element =>element !== 0).length
	const nonzeroDiff = difference.filter (element =>element !== 0).length
	const score = Math.round( (1 - nonzeroDiff/nonzeroSum) * 100)

	return (score) 

}	

export default ScoreFunction;

const demoResult1 =  "11010333".split('').map
	(function(item) {
		return (parseInt(item, 10));
	})

